import { RoommateData } from 'src/features/multi-occupancy/types';

import { studentBookingClient } from '../client';

import {
    ApiBasket,
    BasketUser,
    AddUserToBasketSuccessResponse,
    GetBasketSuccessResponse,
    PostAddRoommatesSuccessResponse,
    PostBasketServiceSuccessResponse,
    PostSignAgreementsSuccessResponse,
    SignAgreementsDto,
    UpdateBasketSuccessResponse,
} from './types';
import { BasketServiceEndpoints } from './constants';
import { CreateBasketDto } from './dto/CreateBasket.dto';
import { UpdateBasketDto } from './dto/UpdateBasket.dto';

export const createBasket = async (basketData: CreateBasketDto): Promise<ApiBasket> => {
    const { data: response } = await studentBookingClient.post<PostBasketServiceSuccessResponse>(
        BasketServiceEndpoints.PostCreateBasket,
        basketData
    );
    return response.data;
};

export const updateBasket = async (
    basketId: string,
    basketData: Partial<ApiBasket>,
    updatedAt: string
): Promise<ApiBasket> => {
    const payload = new UpdateBasketDto(basketData, updatedAt);

    const { data: response } = await studentBookingClient.patch<UpdateBasketSuccessResponse>(
        BasketServiceEndpoints.UpdateBasket.replace('{id}', basketId),
        payload
    );
    return response.data;
};

export const addUserToBasket = async (
    basketId: string,
    userData: BasketUser,
    updatedAt: string
): Promise<ApiBasket> => {
    const { data: response } = await studentBookingClient.post<AddUserToBasketSuccessResponse>(
        BasketServiceEndpoints.PostAddUserToBasket.replace('{id}', basketId),
        { user: userData, updatedAt }
    );
    return response.data;
};

export const getBasket = async (basketId: string): Promise<ApiBasket> => {
    const { data: response } = await studentBookingClient.get<GetBasketSuccessResponse>(
        BasketServiceEndpoints.GetBasket.replace('{id}', basketId)
    );
    return response.data;
};

export const postSignAgreements = async (
    basketId: string,
    agreementsData: SignAgreementsDto,
    updatedAt: string
): Promise<ApiBasket> => {
    const payload = {
        signAgreementsDto: agreementsData,
        updatedAt,
    };

    const { data: response } = await studentBookingClient.post<PostSignAgreementsSuccessResponse>(
        BasketServiceEndpoints.SignAgreements.replace('{id}', basketId),
        payload
    );
    return response.data;
};

export const postAddRoommatesToBasket = async (
    basketId: string,
    roommates: RoommateData[],
    updatedAt: string
) => {
    const payload = {
        room_mates: roommates.map((roommate) => ({
            first_name: roommate.first_name,
            last_name: roommate.last_name,
            email: roommate.email,
        })),
        updatedAt,
    };

    const { data: response } = await studentBookingClient.post<PostAddRoommatesSuccessResponse>(
        BasketServiceEndpoints.PostAddRoommatesToBasket.replace('{id}', basketId),
        payload
    );

    return response.data;
};
